"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Clowned_OnDamageDealtEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let Effect_Clowned_OnDamageDealtEventHandlerScript = class Effect_Clowned_OnDamageDealtEventHandlerScript {
    run(sequence, container, handler, event) {
        if (container.isDeceased(handler.args.scriptArgs.creatorId)) {
            return;
        }
        if ((0, Random_1.randomPercent)() <= 40) {
            container.applyHealing({
                sequence,
                healerId: handler.args.scriptArgs.creatorId,
                targetId: handler.args.scriptArgs.creatorId,
                amount: Math.round(event.args.damage.amount * .5)
            });
        }
    }
};
Effect_Clowned_OnDamageDealtEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Clowned_OnDamageDealt")
], Effect_Clowned_OnDamageDealtEventHandlerScript);
exports.Effect_Clowned_OnDamageDealtEventHandlerScript = Effect_Clowned_OnDamageDealtEventHandlerScript;
